// extracted by mini-css-extract-plugin
export var bannerBlockButton = "bannerBlock-module--bannerBlockButton--1238d";
export var bannerBlockText = "bannerBlock-module--bannerBlockText--cba93";
export var bannerBlockWrapper = "bannerBlock-module--bannerBlockWrapper--93026";
export var bannerBlockWrapperBtn = "bannerBlock-module--bannerBlockWrapperBtn--a3471";